export default __webpack_public_path__ + "static/deepracer-logo-f9fe55b6f66d5284f320c499a94ab672.png";